import ToolToggleBlock from './ToolToggleBlock';

class ToolToggleHeading1 extends ToolToggleBlock {
  static toolName = 'Heading 1';
  static iconClass = 'fa-regular fa-h1';
  static blockType = 'h1';
}

export default ToolToggleHeading1;
